import { useMutation } from '@tanstack/react-query';
import * as z from 'zod';

import { ALLOWED_DAYS } from 'src/features/memberships/types';
import { DURATION, type PrepaidPlan } from 'src/features/subscriptions/types';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/prepaid-plan/';

type FormSchemaValues = z.infer<typeof formSchema>;
const formSchema = z.object({
    plan_name: z.string().min(5),
    languages: z.array(z.string()).nonempty(),
    description: z.string().optional(),
    duration: z.object({
        unit: z.nativeEnum(DURATION),
        value: z.number(),
    }),
    allowedWeekDays: z.array(z.nativeEnum(ALLOWED_DAYS)).nonempty(),
    allowedHours: z.object({
        fromHour: z.string().time(),
        toHour: z.string().time(),
    }),
    dueTaxPercent: z.number(),
    dueTaxAmount: z.number(),
    dueAmount: z.number(),
    dueAmountWithTax: z.number(),
    endAtMidnight: z.boolean(),
});

interface DTO extends FormSchemaValues {
    parkingId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, ...data }: DTO): Promise<PrepaidPlan> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateSubscriptionPlan, formSchema as createSubscriptionPlanFormSchema };
export type { FormSchemaValues as CreateSubscriptionPlanFormSchemaValues };
